<template>
  <idc-component-adjustment-permission-summary :can-create="canCreate" :can-edit="canEdit" :can-delete="canDelete" />
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    name: 'DashboardAdjustmentPermission',
    components: {
      IdcComponentAdjustmentPermissionSummary: () => import('@/components/idc/adjustment/permission/Summary.vue'),
    },
    props: {
      canEdit: {
        type: Boolean,
        default: () => false,
      },
      canDelete: {
        type: Boolean,
        default: () => true,
      },
      canCreate: {
        type: Boolean,
        default: () => true,
      },
    },
  })
</script>
